import {
  ChangePasswordPayload,
  ChangeUserProfilePayload,
  LoginPayload,
  RegisterPayLoad,
  ResetPasswordPayload,
} from '@/types/user'
import axiosClient from './axiosClient'

const authApi = {
  login(payload: LoginPayload) {
    const url = '/api/user/login'
    return axiosClient.post(url, payload)
  },
  forgotPassword(email: string) {
    const url = 'api/user/forgetpassword'
    return axiosClient.post(`${url}?email=${email}`)
  },
  resetPassword(payload: ResetPasswordPayload) {
    const url = '/api/user/resetpassword'
    return axiosClient.post(url, payload)
  },
  changePassword(payload: ChangePasswordPayload) {
    const url = '/api/user/changepassword'
    return axiosClient.post(url, payload)
  },
  register(payload: RegisterPayLoad) {
    const url = '/api/user/register'
    return axiosClient.post(url, payload)
  },
  getProfile() {
    const url = 'api/user/profile'
    return axiosClient.get(url)
  },
  changeProfile(payload: ChangeUserProfilePayload) {
    const url = 'api/user/profile'
    return axiosClient.put(url, payload)
  },
}

export default authApi
